import { render } from "./SendToTg.vue?vue&type=template&id=01afe3c4"
import script from "./SendToTg.vue?vue&type=script&lang=js"
export * from "./SendToTg.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__